import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const supportRoutes: RouteRecordRaw[] = [
  {
    path: routes.HELP,
    name: 'HELP',
    component: () => import('./HelpPage.vue'),
    meta: { requiresAuth: true, title: 'Help & Support' },
  },
  {
    path: routes.HELP_FAQS,
    name: 'HELP_FAQS',
    component: () => import('./HelpFaqsPage.vue'),
    meta: { requiresAuth: true, title: 'FAQs' },
  },
  {
    path: routes.HELP_CONTACT,
    name: 'HELP_CONTACT',
    component: () => import('./HelpContactPage.vue'),
    meta: { requiresAuth: true, title: 'Contact Us' },
  },
]
